/**
 * Lightweight session store for the public demo CBT.
 * Mirrors the mobile demoSlice: fetch questions, answer locally, score on submit.
 */

export const DEMO_DURATION_MS = 4 * 60 * 1000;
export const DEMO_QUESTION_LIMIT = 10;
const STORAGE_KEY = "ots_demo_session";

export function formatDemoClock(ms) {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${minutes}:${seconds}`;
}

export function optionId(option) {
  if (option === null || option === undefined) return "";
  if (typeof option === "string" || typeof option === "number") return String(option);
  return String(option._id || option.id || option.value || "");
}

export function optionText(option) {
  if (option === null || option === undefined) return "";
  if (typeof option === "string" || typeof option === "number") return String(option);
  const raw =
    option.option ||
    option.text ||
    option.title ||
    option.label ||
    option.optionText ||
    option.content ||
    option.answer ||
    "";
  return raw ? String(raw) : "";
}

export function scoreDemoAnswers(questions, selectedAnswers) {
  return (questions || []).reduce((total, question) => {
    const questionId = String(question._id || "");
    const selected = selectedAnswers[questionId];
    const correct = String(question.correctAns || "");
    return selected && selected === correct ? total + 1 : total;
  }, 0);
}

export function saveDemoResult(payload) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (err) {
    // sessionStorage can throw in private mode; the in-memory navigation state still works
  }
}

export function loadDemoResult() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
}

export function clearDemoResult() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    // ignore
  }
}
